module.exports = __webpack_public_path__ + "img/415.6e624a33.jpg";